import { Roles } from '../../utils/enums'
import { Http } from '../../utils/types'
import { GetBlob, ObjectGeneric } from '../../utils/types/generals'
import { getUserRole } from '../auth'
import {
  AssociateDivisionsToCompanies,
  GetAllDivision,
  GetAllDivisionWithFilter,
  ResponseDivision,
} from './response'

export const divisionService = (client: Http) => {
  return {
    getAllDivision: async (): Promise<GetAllDivision> => {
      return client.get('hierarchy/filters/division')
    },
    getAllDivisionWithFilter: async (query?: string): Promise<GetAllDivisionWithFilter> => {
      return await client.get(`division${query ? '?' + query : ''}`)
    },
    downloadFile: async (data: {
      type: string
      query?: string
    }): Promise<GetBlob> =>
      await client.getBlob?.(
        `division/generate-file${data.query ? '?' + data.query + '&type=' + data.type : '?type=' + data.type}`
      ),
    getDivisionsFilter: async (): Promise<GetAllDivision> => {
      return await client.get('report-folio/filters/divisions')
    },
    getAllSupervisorDivision: async (): Promise<GetAllDivision> =>
      await client.get('hierarchy/filters/division'),
    createDivision: async (body: ObjectGeneric): Promise<ResponseDivision> =>
      await client.post('division', body),
    updateDivision: async (
      body: ObjectGeneric,
      id: number
    ): Promise<ResponseDivision> => await client.put(`division/${id}`, body),
    deleteDivision: async (id: number): Promise<ResponseDivision> =>
      await client.delete(`division/${id}`),
    associateDivisionToCompanie: async (
      body: ObjectGeneric
    ): Promise<AssociateDivisionsToCompanies> =>
      await client.post(`division/companies`, body),
  }
}